var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"url":"cart","is-mock":_vm.$route.name.includes('preview')}})}
var staticRenderFns = []

export { render, staticRenderFns }